var TARGET;
var LAYER1;
var LAYER2;
var RoadMapModal = (function (base) {
  __extends(RoadMapModal, base);

    let roadSections = [];
    const MAX_POINTS = 100; // Максимальное кол-во точек редактирования на экране. При превышении которого редактирование линии будет отключено
    const MAX_ZOOM = 17; // Максимальный зум, при достижении которого редактирование будет работать всегда
    let draggable = false; // Можно ли перемещать линию целиком
    

  function RoadMapModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  }

  /**
   * Активизирует диалог
   * @param {} coordinates Массив координат или CSV
   * @param {} roadName Название дороги
   */
  RoadMapModal.prototype.activate = function (roadId, roadName, coordinates, startKm) {
    const self = this;
    const url = roadId ? `api/roads/${roadId}/edit/map` : `api/roads/add/map`;

    this.loadContent(url)
      .then($modal => {

        $('[js=road-name]', $modal).text(roadName);

        if (typeof coordinates === 'string') {
            coordinates = MapHelper.parseStringToSplitLatLng(coordinates);
            if (coordinates === undefined) {
                $('[js=error-text]', this.$modal).text('Ошибка чтения координат. Неверный формат.');
                coordinates = [[]];
            }
        } else {
            coordinates = [MapHelper.convertToLatLng(coordinates)];
        }

        // Инициализация карты после открытия модального окна
        setTimeout(function () {
          const containerHeight = $(window).height() * 0.65;
            $('#marker-map', $modal).height(containerHeight);
            $('#road-help', $modal).height(containerHeight - 70);
          _initMap(coordinates, $('#btn-back', $modal));
        }, 200);

        $modal
            .on('click', '[js=save]', function () {
                self.close({
                    ok: true,
                    coordinatesCsv: _getCsv()
                });
                //if (roadId) {
                //    var length = MapHelper.getLength(_getCoordinates()) / 1000;
                //    _validateRoad(roadId, startKm, length)
                //        .success(function(result) {
                //            self.close({
                //                ok: true,
                //                length: length,
                //                coordinatesCsv: _getCsv()
                //            });
                //        })
                //        .error(function (xhr, status, statusCode) {
                //            var response = xhr.responseJSON;
                //            if (response && response.errors &&
                //                response.errors.StartKm && response.errors.StartKm.length) {
                //                $('[js=error-text]', this.$modal).text(response.errors.StartKm[0]);
                //            }
                //            else
                //                $('[js=error-text]', this.$modal).text('Не удалось сохранить изменения.');
                //        });
                //} else {
                //    self.close({
                //        ok: true,
                //        coordinatesCsv: _getCsv()
                //    });
                //}
            });

      });
  };

    function _validateRoad(roadId, startKm, length) {
        var data = { startKm: startKm, length: length };
        return $.ajax({
            url: Url.action('api/roads/{0}/validate', roadId),
            data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                type: 'POST',
                dataType: 'json'
            });
    }

function _initMap(coordinates, backControl) {
    const latitude = sessionStorage.lat && sessionStorage.lat != 'undefined' ? sessionStorage.lat.replace(',', '.') : 0;
    const longitude = sessionStorage.lng && sessionStorage.lng != 'undefined' ? sessionStorage.lng.replace(',', '.') : 0;
    const initLat = latitude > 0 ? latitude : AppConfig.defaultMapCenter[0];
    const initLng = longitude > 0 ? longitude : AppConfig.defaultMapCenter[1];
    roadSections.length = 0;

    L.Icon.Default.imagePath = AppConfig.imagePath;
    var grayscale = L.tileLayer(MapSettings.urlFormat, { attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' });

    var map = L.map('marker-map', {
      center: [initLat, initLng],
      zoom: AppConfig.defaultMapZoom,
      maxBounds: L.latLngBounds(AppConfig.defaultMapBounds[0], AppConfig.defaultMapBounds[1]),
      minZoom: AppConfig.defaultMapMinZoom,
      zoomReverse: true,
      layers: [grayscale],
      editable: true,
      renderer: L.canvas({padding: 0.3}),
      optimization: true
    });

    L.HelpControl = L.Control.extend({

        onAdd: function (map) {
            var clicked = false;
            var container = L.DomUtil.create('div', 'leaflet-control leaflet-bar'),
                link = L.DomUtil.create('a', '', container);
            L.DomEvent.disableClickPropagation(container);
            link.href = '#';
            link.innerHTML = '?';
            L.DomEvent.on(link, 'click', L.DomEvent.stop)
                .on(link, 'click', function () {
                    if (!clicked && $('#road-help').is(':visible')) {
                        clicked = true;
                    } else {
                        $('#road-help').toggle();
                        clicked = $('#road-help').is(':visible');
                    }
                    if (clicked)
                        $(this).addClass('selected');
                    else
                        $(this).removeClass('selected');
                });
            L.DomEvent.on(link, 'mouseenter', function () {
                $('#road-help').show();
            });
            L.DomEvent.on(link, 'mouseleave', function () {
                if (!clicked)
                    $('#road-help').hide();
            });
            return container;
        }
    });

    L.NewLineControl = L.Control.extend({

        options: {
            position: 'topleft'
        },

        onAdd: function (map) {
            var container = L.DomUtil.create('div', 'leaflet-control leaflet-bar'),
            link = L.DomUtil.create('a', '', container);
            L.DomEvent.disableClickPropagation(container);
            link.href = '#';
            link.innerHTML = '/\\/';
            L.DomEvent.on(link, 'click', L.DomEvent.stop)
                .on(link, 'click', function () {
                    //if (!map.editTools.drawing())
                    if (roadSections.length && roadSections[roadSections.length - 1].getLatLngs().length < 2) {
                        roadSections.splice(roadSections.length - 1, 1);
                    }
                    roadSections.push(map.editTools.startPolyline());
                    updateTooltips();
                });
            return container;
        }
    });

    L.DraggableControl = L.Control.extend({

        options: {
            position: 'topleft'
        },

        onAdd: function (map) {
            var container = L.DomUtil.create('div', 'leaflet-control leaflet-bar'),
            link = L.DomUtil.create('a', '', container);
            L.DomEvent.disableClickPropagation(container);
            link.href = '#';
            link.innerHTML = 'D';
            L.DomEvent.on(link, 'click', L.DomEvent.stop)
                .on(link, 'click', function () {
                    draggable = !draggable;
                    if (draggable) {
                        this.classList.add('selected');
                    } else {
                        this.classList.remove('selected');
                    }
                    setDraggable(draggable);
                });
            return container;
        }
    });
    map.addControl(new L.NewLineControl());
    map.addControl(new L.HelpControl({ position: 'topright' }));
    map.addControl(new L.DraggableControl());

    // click on vertex
    map.on('editable:vertex:ctrlclick editable:vertex:metakeyclick', function (e) {
        var index = e.vertex.getIndex();
        var maxIndex = e.layer.getLatLngs().length;
        // split line
        if (index > 1 && index < maxIndex - 2) {
            e.vertex.split();
            e.layer.getLatLngs()[0][e.layer.getLatLngs()[0].length - 1].__vertex.delete();
            e.layer.getLatLngs()[1][0].__vertex.delete();
            var secondLine = e.layer.editor.deleteShapeAt(e.layer.getLatLngs()[1][0]);
            var firstLine = e.layer.editor.deleteShapeAt(e.layer.getLatLngs()[0][0]);
            var layerIndex = roadSections.indexOf(e.layer);
            if (layerIndex >= 0) {
                roadSections[layerIndex] = L.polyline(firstLine).addTo(map);
                roadSections.splice(layerIndex + 1, 0, L.polyline(secondLine).addTo(map));
                roadSections[layerIndex].enableEdit();
                roadSections[layerIndex + 1].enableEdit();
                updateTooltips();
            }
        }
        // continue line
        else
            e.vertex.continue();
    });
    // delete section
    var deleteShape = function (e) {
        if ((e.originalEvent.ctrlKey || e.originalEvent.metaKey) && this.editEnabled()) {
            var index = roadSections.indexOf(this);
            if (this.editor.drawing()) {
                // При удалении линии, когда находимся в режиме рисования,
                // то удаляем либо саму линию и начинаем ее заново, либо находим пересечение с другими линиями
                // и удаляем первую из найденных
                var intersectedLines = [];
                for (var i = 0; i < roadSections.length; i++) {
                    if (i !== index && roadSections[i].editEnabled()
                        && roadSections[i].editor.feature.shapeAt(e.latlng))
                        intersectedLines.push(i);
                }
                if (intersectedLines.length) {
                    roadSections[intersectedLines[0]].editor.deleteShapeAt(e.latlng);
                    roadSections.splice(intersectedLines[0], 1);
                    updateTooltips();
                } else if (index >= 0) {
                    this.editor.deleteShapeAt(e.latlng);
                    roadSections[index] = map.editTools.startPolyline();
                    updateTooltips();
                }
            } else {
                if (index >= 0) {
                    this.editor.deleteShapeAt(e.latlng);
                    roadSections.splice(index, 1);
                    updateTooltips();
                }
            }
        }
    };
    map.on('layeradd', function (e) {
        if (e.layer instanceof L.Path) e.layer.on('click', L.DomEvent.stop).on('click', deleteShape, e.layer);
    });
    //// redo
    //var Z = 90, latlng, redoBuffer = [],
    //    onKeyDown = function (e) {
    //        if (e.keyCode == Z) {
    //            if (!this.editTools._drawingEditor) return;
    //            if (e.shiftKey) {
    //                if (redoBuffer.length) this.editTools._drawingEditor.push(redoBuffer.pop());
    //            } else {
    //                latlng = this.editTools._drawingEditor.pop();
    //                if (latlng) redoBuffer.push(latlng);
    //            }
    //        }
    //    };
    //L.DomEvent.addListener(document, 'keydown', onKeyDown, map);
    //map.on('editable:drawing:end', function () {
    //    redoBuffer = [];
    //    placeMarkersInBounds();
    //});

    map.on('editable:drawing:end', function () {
        $('[js=error-text]', this.$modal).text('');
        refreshEditor();
    });

    if (!coordinates.length || !coordinates[0].length) {
        roadSections.push(map.editTools.startPolyline());
    } else {
        coordinates.forEach(function (c) {
            roadSections.push(L.polyline(c).addTo(map));
            roadSections[roadSections.length - 1].enableEdit();
        });
        var latLngs = roadSections.map(function(s) { return s.getLatLngs(); });
        map.fitBounds(L.latLngBounds(latLngs));
    }
    updateTooltips();

    // disable edit if many points on screen
    map.on('moveend', placeMarkersInBounds);
    refreshEditor();
    redrawPoints();
    setDraggable(draggable);

    function setDraggable(enable) {
        for (let i = 0; i < roadSections.length; i++) {
            if (enable) {
                roadSections[i].dragging.enable();
            } else {
                roadSections[i].dragging.disable();
            }
        }
    }

    function redrawPoints() {
        for (let i = 0; i < roadSections.length; i++) {
            if (roadSections[i].editor && roadSections[i].editEnabled())
                roadSections[i].editor.reset();
        }
    }

    function refreshEditor() {
        var currentZoom = map.getZoom();
        if (currentZoom >= MAX_ZOOM) { //|| map.editTools.drawing()
            for (let i = 0; i < roadSections.length; i++) {
                if (!roadSections[i].editEnabled())
                    roadSections[i].enableEdit();
            }
        } else {
            var mapBounds = map.getBounds();
            var visibleSections = [];
            var visiblePoints = 0;
            var disableAll = false;
            for (let i = 0; i < roadSections.length; i++) {
                
                if (roadSections[i].editor && roadSections[i].editor.drawing())
                    continue;
                var bounds = roadSections[i].getBounds();
                if (!bounds || !bounds.isValid())
                    continue;
                if (mapBounds.intersects(bounds)) {
                    visibleSections.push(i);
                    if (!disableAll) {
                        visiblePoints += roadSections[i].getLatLngs().filter(function (c) {
                            return mapBounds.contains([c.lat, c.lng]);
                        }).length;
                        if (visiblePoints > MAX_POINTS) {
                            disableAll = true;
                        }
                    }
                } else {
                    if (roadSections[i].editEnabled())
                        roadSections[i].disableEdit();
                }
            }
            if (disableAll) {
                for (let i = 0; i < visibleSections.length; i++) {
                    if (roadSections[visibleSections[i]].editEnabled())
                        roadSections[visibleSections[i]].disableEdit();
                }
            } else {
                for (let i = 0; i < visibleSections.length; i++) {
                    if (!roadSections[visibleSections[i]].editEnabled())
                        roadSections[visibleSections[i]].enableEdit();
                }
            }
        }
    }

    function placeMarkersInBounds() {
        refreshEditor();
        redrawPoints();
        setDraggable(draggable);
    }

    function updateTooltips() {
        if (roadSections.length) {
            if (roadSections.length === 1) {
                if (roadSections[0].getTooltip())
                    L.DomEvent.off(roadSections[0], 'tooltipopen', closeTooltip, roadSections[0]);
                    roadSections[0].unbindTooltip();
            } else {
                for (var i = 0; i < roadSections.length; i++) {
                    roadSections[i].bindTooltip('Линия ' + (i + 1), { sticky: true });
                    L.DomEvent.off(roadSections[i], 'tooltipopen', closeTooltip, roadSections[i]);
                    L.DomEvent.on(roadSections[i], 'tooltipopen', closeTooltip, roadSections[i]);
                }
            }
        }
    }

    function closeTooltip(e) {
        var layer = this;
        setTimeout(function() {
                layer.closeTooltip();
            }, 1200);
    }

}

    function _getCsv() {
        return roadSections
            .map(function(s) {
                return s.getLatLngs().map(function(l) { return l.lat + ',' + l.lng; }).join('\n');
            }).join('\n---\n');
    }

    function _getCoordinates() {
        return roadSections.map(function (s) { return s.getLatLngs(); });
    }

  return RoadMapModal;
}(BaseModal));
